import { Theme } from '@material-ui/core';
import { defaultsDeep } from 'lodash';

const getPropsLumaDark = (
  {
    palette: {
      primary,
      common: { white },
    },
  }: Theme,
  defaults: any,
) =>
  defaultsDeep(
    {},
    {
      themeName: 'LumaDark',
      palette: {
        type: 'dark',
      },
      overrides: {
        MuiPaper: {
          root: {
            backgroundColor: primary.main,
          },
        },
        MuiTypography: {
          root: {
            color: `${white} !important`,
          },
        },
        MuiButton: {
          textPrimary: {
            color: white,
          },
        },
      },
    },
    defaults,
  );

export default getPropsLumaDark;
